import {SELECTED_INDEX} from './selectedTypes'

const initialState = {
    index: 0
}

const selectedReducer = (state = initialState, action) => {
    
    switch (action.type) {
        case SELECTED_INDEX:
            
            return {
                index: action.payload
            }
    
        default:
          return state
    }

}


export default selectedReducer;